var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("bulma-autocomplete", {
    attrs: {
      id: _vm.id + "_address",
      placeholder: "Suburb",
      data: _vm.localities.data,
      field: "text",
      loading: _vm.localities.isFetching,
      "max-results": _vm.mapboxMap.limit,
    },
    on: {
      input: _vm.mapboxLocalitySearch,
      select: function ($event) {
        return _vm.onSuburbSelect($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c("div", [
              _c("span", { staticClass: "icon is-small" }, [
                _c("i", { staticClass: "mdi mdi-map-marker" }),
              ]),
              _vm._v(" " + _vm._s(`${props.option.place_name}`) + " "),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.suburb,
      callback: function ($$v) {
        _vm.suburb = $$v
      },
      expression: "suburb",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }